import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandingService } from '@next/core-lib/branding';
import { of } from 'rxjs';
import { catchError, distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';

import { EmployeeRelatedCustomer } from '../../models/employee.model';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-employee-relations',
  templateUrl: './employee-relations.component.html',
  styleUrls: ['./employee-relations.component.scss'],
  standalone: false,
})
export class EmployeeRelationsComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly employeeService = inject(EmployeeService);
  private readonly brandingService = inject(BrandingService);

  readonly employeeId = Number(
    this.route.parent?.parent?.snapshot.paramMap.get('employeeId') ?? undefined,
  );
  readonly loadFailed = signal(false);
  readonly isAgrifirm = this.brandingService.isTenant('Agrifirm');
  readonly emptyCustomers = computed(() => !this.loadFailed() && this.customers()?.length === 0);
  readonly customers = toSignal(
    this.route.parent!.parent!.paramMap.pipe(
      map((params) => Number(params.get('employeeId') ?? undefined)),
      filter((employeeId) => !Number.isNaN(employeeId)),
      distinctUntilChanged(),
      switchMap((employeeId) =>
        this.employeeService.getRelatedCustomers(employeeId).pipe(
          tap(() => this.loadFailed.set(false)),
          catchError(() => {
            this.loadFailed.set(true);
            return of([] as EmployeeRelatedCustomer[]);
          }),
        ),
      ),
    ),
    { initialValue: undefined as EmployeeRelatedCustomer[] | undefined },
  );

  addRelation() {
    this.router.navigate(['add'], {
      relativeTo: this.route,
      queryParamsHandling: 'preserve',
    });
  }
}
